<template>
	<Modal v-model="view.showPrivacy" :closable='false' :mask-closable='false' :fullscreen='true'>
		<template #header>
			<p style="text-align:center;">
				<span>隐私协议</span>
			</p>
		</template>
		<div>
			<p v-html="view.privacy"></p>
		</div>
		<template #footer>
			<Space direction="vertical" type="flex">
				<Button type="success" @click="view.showPrivacy=false;"  long>我知道了</Button>
			</Space>
		</template>
	</Modal>
	<div v-if="isNullOrEmptyEx(view.exclusiveId)">
		<v-header title="登录/注册" />
		<div class="sysMain">
			<div class="sysMainBody">
				<Form ref="form" :model="model" :rules="ruleValidate" :label-width="80">
					<FormItem label="手机号码" prop="patientPhone">
						<Input v-model="model.patientPhone" placeholder="请输入" maxlength="11"></Input>
					</FormItem>
					<FormItem label="验证码" prop="code">
						<Input v-model="model.code" placeholder="请输入" maxlength="4"
							style="width:calc(100% - 110px) "></Input>
						<Button type="primary" @click="send" :disabled="view.loading">
							<span v-if="!view.loading">获取验证码</span>
							<span v-else>{{'倒计时'+view.countDown}}</span>
						</Button>
					</FormItem>
				</Form>
				<div style="text-align: center;">
					<Button type="primary" ghost icon="md-checkmark" @click="register()">提交</Button>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
	<div v-else>
		<v-header title="专属下单" />
		<div class="sysMain">
			<div class="sysMainBody">
				<div style="text-align: center;padding-bottom: 20px;">
					<img :src="view.server+'Files/Img/'+view.exclusiveId+'.png'" />
				</div>
				<Form ref="form" :model="model" :rules="ruleValidate" :label-width="80">
					<FormItem label="手机号码" prop="patientPhone">
						<Input v-model="model.patientPhone" placeholder="请输入" maxlength="11"></Input>
					</FormItem>
					<FormItem label="验证码" prop="code">
						<Input v-model="model.code" placeholder="请输入" maxlength="4"
							style="width:calc(100% - 110px) "></Input>
						<Button type="primary" @click="send" :disabled="view.loading">
							<span v-if="!view.loading">获取验证码</span>
							<span v-else>{{'倒计时'+view.countDown}}</span>
						</Button>
					</FormItem>
				</Form>
				<div style="text-align: center;">
					<Button type="primary" ghost icon="md-checkmark" @click="register()">提交</Button>
				</div>
			</div>


		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import footer from "@/components/footer/index";
	import {
		getToken,
		setToken,
		setExclusiveId
	} from '@/utils/auth'
	import {
		sysPost,
		sysPostWx
	} from '@/utils/api'
	export default {
		data() {
			return {
				view: {
					loading: false,
					time: {},
					countDown: 60,
					server: process.env.VUE_APP_Server,
					exclusiveId: '',
					jumpUrl: '/home',
					showPrivacy: false,
					privacy: '',
				},
				openId: '',
				model: {},
				ruleValidate: {
					patientPhone: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				category: "网站",
				registerResult: {}
			}
		},
		created() {
			var that = this;
			that.init(function(result) {
				var exclusiveid = that.getQueryVariable("exclusiveid");
				if (!that.isNullOrEmptyEx(exclusiveid)) {
					setExclusiveId(exclusiveid);
					that.view.exclusiveId = exclusiveid;
				}
				var jumpUrl = that.getQueryVariable("url");
				if (!that.isNullOrEmptyEx(jumpUrl)) that.view.jumpUrl = jumpUrl;
				var token = getToken();
				if (token) that.Jump();
				else {
					var OpenId = that.getQueryVariable("OpenId");
					var code = that.getQueryVariable("code");
					if (!that.isNullOrEmptyEx(OpenId)) {
						that.openId = OpenId;
						var args = {
							openId: OpenId,
							name: "无",
						}
						that.login(args)
					} else if (!that.isNullOrEmptyEx(code)) {
						if (code.Length == 5) that.$Message.error(code);
						else that.weixin(code);
					}
				}
			});
		},
		methods: {
			init(callback) {
				var that = this;
				sysPost(that, {
					"url": 'Common/SysConfiguration',
					"data": {}
				}, function(result) {
					if (!that.isNullOrEmptyEx(result.viewPrivacy)) {
						that.view.privacy = result.viewPrivacy;
						that.view.showPrivacy = true;
					}
					if (callback) return callback(result)
				})
			},
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
			weixin(code) {
				var that = this;
				sysPostWx(that, {
					"url": 'User/LoginCode',
					"data": {
						"Code": code
					}
				}, function(result) {
					that.category = "公众号";
					that.openId = result.openId;
					that.login(result)
				}, function(result) {
					that.$Message.error(result.Msg);
				})
			},
			login(args) {
				var that = this;
				sysPost(that, {
					"url": 'Wx/Login',
					"data": {
						"Name": args.name,
						"OpenId": args.openId,
						"Category": that.category
					}
				}, function(result) {
					setToken(result)
					that.$router.push({
						path: that.view.jumpUrl,
					})
				});
			},
			send() {
				if (this.isNullOrEmptyEx(this.model.patientPhone)) {
					this.$Message.error('手机号不能为空!');
					return false;
				}
				var that = this;
				that.view.loading = true;
				that.view.countDown = 120;
				that.view.timer = setInterval(() => {
					if (that.view.countDown === 1) {
						that.view.loading = false;
						that.view.countDown = 120;
						clearInterval(that.view.timer);
					} else that.view.countDown--;
				}, 1000)
				sysPost(that, {
					"url": 'Wx/SMSSend',
					"data": {
						"Category": "注册",
						"Mobile": that.model.patientPhone
					}
				}, function(result) {
					that.$Message.success('发送成功！');
				}, function(result) {
					that.view.loading = false;
					that.$Message.info(result.Msg);
				});
			},
			register(args) {
				var that = this;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						sysPost(that, {
							"url": 'Wx/Register',
							"data": {
								"PatientPhone": that.model.patientPhone,
								"Code": that.model.code,
								"OpenId": that.openId
							}
						}, function(result) {
							setToken(result)
							that.Jump();
						});
					}
				})
			},
			Jump() {
				var that = this;
				that.$router.push({
					path: that.view.jumpUrl,
				})
			}
		},
		components: {
			"v-footer": footer,
			"v-header": header
		},
	}
</script>